import * as ActionTypes from '../constants/actionTypes'
import {
  createGroup, deleteSellerGroup,
  editGroup,
  getGroupsOfSellers,
  sellerGetCount,
  sellerGetPage
} from '../api/seller'
import {
  SELLERLIST_GROUPFORM_CHANGE,
  SELLERLIST_GROUPFORM_CREATE_LOAD,
  SELLERLIST_GROUPFORM_EDIT_LOAD,
  SELLERLIST_GROUPFORM_ITEMS_HAS_NO_MORE,
  SELLERLIST_GROUPFORM_REMOVE_LOAD,
} from '../constants/actionTypes'

export const changePaginationGroupForm = newPage => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERLIST_GROUPFORM_FETCHITEMS_CHANGE_PAGINATION, page: newPage })
}

export const removeSellerGroup = ({ id }) => async (dispatch) => {
  dispatch({
    type: SELLERLIST_GROUPFORM_REMOVE_LOAD,
  })
  try {
    await deleteSellerGroup({
      idnum: id,
    })
    dispatch({
      type: ActionTypes.SELLERLIST_GROUPFORM_REMOVE_SUCCEED,
    })
    location.reload()
  } catch (e) {
    console.log(e)
    dispatch({
      type: ActionTypes.SELLERLIST_GROUPFORM_REMOVE_FAIL,
      groupFormError: 'Ошибка удаления группы',
    })
  }
}

/**
 * Edit sellers group.
 * @param groupSellers {string []} Array of sellers id.
 * @param groupName {string} Name of editable group
 * @param groupId {string} Id of group.
 * @returns {(function(*): Promise<void>)|*}
 */
export const editSellerGroup = ({ groupSellers, groupId }) => async (dispatch) => {
  dispatch({
    type: SELLERLIST_GROUPFORM_EDIT_LOAD,
  })
  try {
    await editGroup({
      sellers: groupSellers,
      idnum: groupId,
    })
    dispatch({
      type: ActionTypes.SELLERLIST_GROUPFORM_EDIT_SUCCEED,
    })
    location.reload()
  } catch (e) {
    console.log(e)
    dispatch({
      type: ActionTypes.SELLERLIST_GROUPFORM_EDIT_FAIL,
      groupFormError: 'Ошибка редактирования группы',
    })
  }
}

/**
 * Edit sellers group.
 * @param groupSellers {string []} Array of sellers id.
 * @param groupName {string} Name of editable group
 * @param groupId {string} Id of group.
 * @returns {(function(*): Promise<void>)|*}
 */
export const createSellerGroup = ({ groupSellers, groupName }) => async (dispatch) => {
  dispatch({
    type: SELLERLIST_GROUPFORM_CREATE_LOAD,
  })
  try {
    await createGroup({ name: groupName, sellers: groupSellers })
    dispatch({
      type: ActionTypes.SELLERLIST_GROUPFORM_CREATE_SUCCEED,
    })
    location.reload()
  } catch (e) {
    console.log(e)
    dispatch({
      type: ActionTypes.SELLERLIST_GROUPFORM_CREATE_FAIL,
      groupFormError: 'Ошибка создания группы',
    })
  }
}

/**
 * Fetch items.
 * @param params {{page:number, search:string}}
 * @returns {(function(*): Promise<void>)|*}
 */
export const fetchItemsForGroups = (params = {}) => async (dispatch) => {
  dispatch({ type: ActionTypes.SELLERLIST_GROUPFORM_FETCHITEMS_LOAD })
  const { page, search } = params
  const defaultPart = 20
  return sellerGetPage({
    current: page,
    pageSize: defaultPart,
    search,
    sort: undefined,
    order: undefined,
    group: undefined,
  })
    .then(res => res.result)
    .then((items) => {
      if (items.length === defaultPart) {
        dispatch({
          type: SELLERLIST_GROUPFORM_ITEMS_HAS_NO_MORE,
          hasNoMore: false,
        })
      } else {
        dispatch({
          type: SELLERLIST_GROUPFORM_ITEMS_HAS_NO_MORE,
          hasNoMore: true,
        })
      }
      page === 1
        ?
        dispatch({
          type: ActionTypes.SELLERLIST_GROUPFORM_FETCHITEMS_SUCCEED,
          items,
        })
        :
        dispatch({
          type: ActionTypes.SELLERLIST_GROUPFORM_FETCHITEMS_LAZY_LOADING_SUCCEED,
          items,
        })
    })
    .catch((e) => {
      dispatch({
        type: ActionTypes.SELLERLIST_GROUPFORM_EDIT_FAIL,
        groupFormError: 'Ошибка редактирования группы',
      })
    })
}

export const changeGroupForm = (params = {}) => (dispatch) => {
  dispatch({
    type: SELLERLIST_GROUPFORM_CHANGE,
    fields: params,
  })
}


export const fetchItems = (params = {}) => (dispatch) => {
  const {
    current, pageSize, search, sort, order, group,
  } = params

  dispatch({ type: ActionTypes.SELLERLIST_FETCHITEMS_LOAD })

  sellerGetCount({ search, group }).then((res) => {
    const total = parseInt(res.result.n_count)
    const result = {
      n_balance: res.result.n_balance,
      points: res.result.points,
      kassa: res.result.kassa,
      checks: res.result.checks,
      checks_last_day: res.result.checks_last_day,
      epo: res.result.epo
    }

    sellerGetPage({
      current, pageSize, search, sort, order, group,
    }).then((res) => {
      const items = res.result
      const newItems = items
      items.map((obj, key) =>
        newItems[key].n_disable = obj.n_disable === '1')
      items.map((obj, key) =>
        newItems[key].n_disable_billing = obj.n_disable_billing === '1')

      dispatch({
        type: ActionTypes.SELLERLIST_FETCHITEMS_SUCCEED,
        items: newItems,
        result: result,
        total,
      })
    }).catch((err) => {
      dispatch({
        type: ActionTypes.SELLERLIST_FETCHITEMS_FAIL,
        fetchItemsError: 'Ошибка получения списка торговых сетей',
      })
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERLIST_FETCHITEMS_FAIL,
      fetchItemsError: 'Ошибка получения кол-ва торговых сетей',
    })
  })
}


/**
 * Fetch groups of seller for current user.
 */
export const fetchGroups = () => async (dispatch) => {
  dispatch({
    type: ActionTypes.SELLERLIST_FETCHGROUPS_LOAD,
  })
  let groups = []
  try {
    groups = await getGroupsOfSellers()
    dispatch({
      type: ActionTypes.SELLERLIST_FETCHGROUPS_SUCCEED,
      sellerGroups: groups,
    })
  } catch (error) {
    console.error(error)
    dispatch({
      type: ActionTypes.SELLERLIST_FETCHGROUPS_FAIL,
      fetchItemsError: 'Ошибка получения списка груп',
    })
  }
}

export const changeTable = params => (dispatch) => {
  const { pagination = {}, filters = {}, sorter = {} } = params
  dispatch({
    type: ActionTypes.SELLERLIST_CHANGETABLE_CHANGE,
    pagination,
    filters,
    sorter,
  })
}

export const searchTable = ({ isSearching }) => (dispatch) => {
  dispatch({
    type: ActionTypes.SELLERLIST_SEARCHTABLE_SEARCH,
    isSearching,
  })
}

export const editSearch = params => (dispatch) => {
  const { search } = params
  dispatch({
    type: ActionTypes.SELLERLIST_SEARCHTABLE_EDIT,
    search,
  })
}




// WEBPACK FOOTER //
// src/actions/sellerList.js